import { Inject, Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    config = {};

    constructor(@Inject(Injector) private injector: Injector) {
    }

    // Need to get ToastrService from injector rather than constructor injection to avoid cyclic dependency error
    private get notification(): ToastrService {
        return this.injector.get(ToastrService);
    }

    clear(): void {
        this.notification.clear();
    }

    sucesso(mensagem: string): void {
        this.notification.success(mensagem, 'Sucesso', this.config);
    }

    alerta(mensagem: string): void {
        this.notification.warning(mensagem, 'Atenção', this.config);
    }

    erro(mensagem: string): void {
        this.notification.error(mensagem, 'Erro', this.config);
    }

}
